import type { FaireProductEntity } from "../../entity_types/product";

export const p_wrwzfb3ryx: FaireProductEntity = {
  token: "p_wrwzfb3ryx",
  type: "product",
  name: "Milo Cotton Sweater (2XS/S - 2M/L)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/62dcf9f9bfdef90f8b272ceffe0d38e615aaae1ddf47af663e5454586adb372f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e42717b83865da187895500673f8603e8cff43fe78ecad41bfdb8fe455c0d646.jpeg",
    "https://cdn.faire.com/fastly/51b89a26743cceffd070cf0316edf1151245026ebb2d565fbf47d657db2b89d9.jpeg",
    "https://cdn.faire.com/fastly/eb74690ad87074547d8e1c36860d19d51fe92aa3d2ca4c550d18f93e58d2d772.jpeg",
    "https://cdn.faire.com/fastly/b655cb4fc0ae90f6a76692a46a711eb90f544a849712eef5510673dd51130de7.jpeg",
    "https://cdn.faire.com/fastly/e6c474a89e002306041e507f192c44c60d626b0c34875dd67222433e5310e254.jpeg",
    "https://cdn.faire.com/fastly/bb788800c02a9b42d9dd8ddf98c18451c1b5618270634f647cc698eb5fdf98d7.jpeg",
    "https://cdn.faire.com/fastly/62ec5e00b125e8b44f263b968b38bf9cc91f180d58a006eecb2c07626137be38.jpeg",
    "https://cdn.faire.com/fastly/eb2fe292fc10720ba38f6b018dc067d4dd533b621743f063129c43352a789160.jpeg",
    "https://cdn.faire.com/fastly/1283fba9687d522e24ba2a07212baccbd93784ebcfba79093a168ec4fea93031.jpeg",
    "https://cdn.faire.com/fastly/514f24273cd7291cfdb951a6f999b9fa320828a5941d881e45039812427ba870.jpeg",
    "https://cdn.faire.com/fastly/3690682995fe50de6ab7ba3ef8ebbc5e3d28fa4cd5d4357ab43aea5de3ed8c54.jpeg",
    "https://cdn.faire.com/fastly/261f39535a4f357a3f4acf7b934e47d1e0192cdf9a9d7b5568dad00d113fa17b.jpeg",
    "https://cdn.faire.com/fastly/ca44c995d4be0bd2e883966a30e37b1122d0337b2ebb7595a82166bcba78bf53.jpeg",
    "https://cdn.faire.com/fastly/1c25ac5f527387aec1e7ca497705965a14163817fae20c67e0260c6e67a6cc11.jpeg",
    "https://cdn.faire.com/fastly/76342e0c050c6b14186ec62887b88f8b065dbb6f0d9b7b328fad351031ec0137.jpeg",
  ],
  priceDollars: 260,
  description:
    'Why we made this?\n\nThe sweater of the season. Made from lightweight cotton, the Milo Sweater effortlessly elevates any look with its classic round neckline, gently lived-in fit that gets better with time, and airy feel that makes it perfect for layering in warmer months.\n\n𝐂𝐨𝐧𝐭𝐞𝐧𝐭𝐬:\n\n100% Cotton\n\n𝐂𝐚𝐫𝐞 𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\n\n• Hand wash with like colors and in cold water or Machine wash in the mesh bag\n• Recommend to Lay Flat Dry for the best result, but tumble dry low heat in the mesh bag should be fine!\n\n𝐀𝐩𝐩𝐫𝐨𝐱𝐢𝐦𝐚𝐭𝐞 𝐌𝐞𝐚𝐬𝐮𝐫𝐞𝐦𝐞𝐧𝐭𝐬:\n\nXS/S - Length: 24", Chest: 22 1/2"\n\nM/L - Length: 24 1/2", Chest: 23 1/2"\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip: 36" and wearing a size XS/S\n\nMSRP: $130 USD',
  tags: [],
  msrpDollars: 520,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:51:56.672Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
